import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'

import * as routes from 'core/routing/constants/index'
import useGetCar from 'core/hooks/useGetCar'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import TitleIcon from 'core/layouts/title-icon'
import wizardsShape from 'core/components/wizard/shapes'
import { Form, Row } from 'core/components/ui'

import FORM_FIELDS_TYPE from './fields-structure/constants'
import { getFormFields, checkRequiredAdditionnalFormFields } from './fields-structure'
import { tradeInShape } from '../shapes'

const Historical = props => {
  const { intl, history, tradeIn, setTradeIn, setWizards, wizards, form } = props
  const { vehicle, futherInformations } = tradeIn
  const { historical, mileage, dateOfRegistration } = vehicle

  const {
    loading,
    getParamsFinancingQuestion,
    paramsFinancingQuestion,
    getReferencesTrailerHitches,
    referencesTrailerHitches
  } = useGetCar({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const changeDisabledNextStep = isActive => {
    const aStepsActive = wizards[wizards.activeWizard]
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_HISTORICAL) + 1
    const extendedStep = { ...aStepsActive[nextIndex], isActive }
    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  useEffect(() => {
    if (
      historical &&
      futherInformations &&
      mileage &&
      mileage > 0 &&
      historical.firstHand !== undefined &&
      historical.imported !== undefined &&
      historical.maintained !== undefined &&
      futherInformations.funding !== undefined &&
      dateOfRegistration &&
      checkRequiredAdditionnalFormFields(vehicle)
    ) {
      changeDisabledNextStep(true)
    } else {
      changeDisabledNextStep(false)
    }
  }, [futherInformations, vehicle])

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.TRADEIN_HISTORICAL)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep
    if (!isActive) {
      history.push(routes.HOME)
    }
    getParamsFinancingQuestion()
    getReferencesTrailerHitches()
  }, [])

  return (
    <MainContentWrapper>
      <TitleIcon
        cssId="globaldealer-title-5"
        title={intl.formatMessage({
          id: 'tradeIn-historical-view-title2'
        })}
      />
      {getFormFields(FORM_FIELDS_TYPE.VEHICLE_HISTORY).map((categories, i) => (
        <React.Fragment key={i}>
          <Row gutter={30}>
            {categories.nodes.map((FormItem, index) => (
              <FormItem
                key={index}
                form={form}
                loading={loading}
                setTradeIn={setTradeIn}
                tradeIn={tradeIn}
                trailerHitches={referencesTrailerHitches}
                vehicle={vehicle}
              />
            ))}
          </Row>
        </React.Fragment>
      ))}

      <TitleIcon
        cssId="globaldealer-title-6"
        title={intl.formatMessage({
          id: 'tradeIn-historical-view-title3'
        })}
      />
      {getFormFields(FORM_FIELDS_TYPE.VEHICLE_FINANCING).map((categories, i) => (
        <React.Fragment key={i}>
          <Row gutter={30}>
            {categories.nodes.map((FormItem, index) => (
              <FormItem
                key={index}
                loading={loading}
                paramsFinancingQuestion={paramsFinancingQuestion}
                setTradeIn={setTradeIn}
                tradeIn={tradeIn}
              />
            ))}
          </Row>
        </React.Fragment>
      ))}
    </MainContentWrapper>
  )
}

Historical.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  form: PropTypes.shape().isRequired
}

export default withRouter(injectIntl(Form.create()(Historical)))
